import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { UserRole } from '../../types/user';

interface RequireAuthProps {
  children: ReactNode;
  allowedRoles?: UserRole[];
  redirectTo?: string;
}

const RequireAuth: React.FC<RequireAuthProps> = ({
  children,
  allowedRoles = [],
  redirectTo = '/login'
}) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh'
      }}>
        <div>Loading...</div>
      </div>
    );
  }

  // If user is not logged in, redirect to login page
  if (!currentUser) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  // If roles are specified and user doesn't have any of them, redirect to home
  if (allowedRoles.length > 0 && !allowedRoles.includes(currentUser.role as UserRole)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
